import UI_SHARED_LABEL__token from '@/components/shared/UI_SHARED_LABEL__token';
import NotifierBorder from '@/components/ui/notifier/notifier-border';
import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { use_slice_search, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_search_tokens_delete } from '@/state/search/tokens/remote_search_tokens_delete';
import { remote_search_tokens_update_visibility } from '@/state/search/tokens/remote_search_tokens_update_visibility';
import { get_token_style_color, getTokenClassName } from '@/utils/utils_tokens';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { useState } from 'react';
import { ButtonTokenDelete } from '../../_base/buttons/ButtonTokenDelete';
import { ButtonTokenUpdateVisibility } from '../../_base/buttons/ButtonTokenUpdateVisibility';

interface Props {
  item: DTO__token;
}

export const STokensListItem: React.FC<Props> = ({ item }) => {
  const dispatch = use_dispatch();

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { search_current } = use_slice_search(['search_current']);
  const { global_is_desktop } = use_slice_ui(['global_is_desktop']);

  const component_id = `${ENUM__component_type.PAGE_SEARCH_TOKEN_BAR}_${item.word_english.toUpperCase()}_${search_current._id}`;
  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.ENTITY_SEARCH);

  const [isMouseOver, setIsMouseOver] = useState(false);

  const render_button_update_visibility = () => {
    if (!isMouseOver && global_is_desktop) return <></>;
    if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_SEARCH_UPDATE)) return <></>;

    return (
      <ButtonTokenUpdateVisibility
        item={item}
        entity_id={search_current._id}
        send_request={request => dispatch(remote_search_tokens_update_visibility(request))}
        required_permission={ENUM__workspace_entity_feature.ENTITY_SEARCH_UPDATE}
      />
    );
  };

  const render_button_delete = () => {
    if (!isMouseOver && global_is_desktop) return <></>;

    return (
      <ButtonTokenDelete
        item={item}
        entity_id={search_current._id}
        send_request={request => dispatch(remote_search_tokens_delete(request))}
        required_permission={ENUM__workspace_entity_feature.ENTITY_SEARCH_UPDATE}
      />
    );
  };

  return (
    <div
      className={`relative w-full flex items-center h-8
            ${getTokenClassName(item)} 
        `}
      style={{ color: get_token_style_color(item) }}
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      <NotifierBorder notifier={notifier} />
      <div className="min-w-[2.063rem] min-h-2.5 flex items-center justify-start">{render_button_update_visibility()}</div>
      <div className={`flex items-center justify-between w-full`}>
        <p className={`text-left truncate`}>{<UI_SHARED_LABEL__token field={item} />}</p>
      </div>

      {render_button_delete()}
    </div>
  );
};
